export const statusColorMappings = {
  LOCKED:'status status-red',
  ACTIVE: 'status status-green',
  INACTIVE: 'status status-purple'
};
